import { HeadingPriority } from "atoms/constants/heading-priority";
import RemoteImage from "atoms/images/remote-image";
import Heading from "atoms/typography/heading";
import Paragraph from "atoms/typography/paragraph";
import React from "react";
import { t } from "utilities/localization-utils";

const CSS_CLASS_NAME = "c-publication-accordion-panel-header";

interface PublicationAccordionPanelHeaderProps {
    coverImageFileId?: number;
    numberOfBookmarks?: number;
    title: string;
}

const PublicationAccordionPanelHeader = (
    props: PublicationAccordionPanelHeaderProps
) => {
    const { coverImageFileId, numberOfBookmarks, title } = props;
    return (
        <div className={`${CSS_CLASS_NAME}`}>
            <div className={`${CSS_CLASS_NAME}__image`}>
                {coverImageFileId ? (
                    <RemoteImage fileId={coverImageFileId} />
                ) : (
                    <div className={`${CSS_CLASS_NAME}__placeholderImage`} />
                )}
            </div>
            <div className={`${CSS_CLASS_NAME}__text`}>
                <Heading
                    cssClassName={`${CSS_CLASS_NAME}__title`}
                    priority={HeadingPriority.Four}>
                    {title}
                </Heading>
                <Paragraph
                    cssClassName={`${CSS_CLASS_NAME}__bookmarkCountSubtitle`}>
                    {t(
                        numberOfBookmarks === 1
                            ? "bookmarkWithCount"
                            : "bookmarkWithCount_plural",
                        { count: numberOfBookmarks }
                    )}
                </Paragraph>
            </div>
        </div>
    );
};

export default PublicationAccordionPanelHeader;
